import Model, { ID, Integer } from 'src/models/Model'

export default class OauthApplication extends Model {
  static name = 'OauthApplication'

  static define () {
    this.fields = {
      id: {
        type: ID,
        required: true
      },
      name: {
        type: String,
        default: null
      },
      transferDelayDays: {
        type: Integer,
        default: 10
      },
      includeInTransfer: {
        type: Boolean,
        default: false
      },
      uid: {
        type: String,
        excludeFromDefault: true,
        output: true
      },
      secret: {
        type: String,
        excludeFromDefault: true,
        output: true
      }
    }
  }
}
